@import 'styles/mixins';
@import 'styles/variables';

$sectionRadius: 8px;

.rowStyles {
  @include lg-semibold;

  color: var(--neutral-90);
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  .text {
    @include md-regular;

    color: var(--neutral-40);

    b {
      color: var(--negative-50);
    }
  }

  &.marginBottom {
    margin-bottom: 20px;
  }

  .important {
    color: var(--negative-50);
  }
}

.section {
  display: flex;
  flex-flow: row wrap;
  border-radius: $sectionRadius;
  margin: 0;

  header {
    @include header-lg-bold;
    color: var(--neutral-90);
    padding: 0 0 32px 0;
    flex: 1 100%;
  }

  &Content {
    background-color: var(--neutral-0);
    border-radius: $sectionRadius;
    padding: 4px 32px 30px;
    flex: 1 100%;
    border: 1px solid var(--neutral-20);
  }

  &FieldWrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    &.alignTop {
      display: flex;
      align-items: flex-start;
      padding: 20px 0;

      &.noPadding {
        padding: 0;
      }
    }
  }

  &Label {
    @include inter-medium;
    font-size: 15px;
    line-height: 21px;
    color: var(--neutral-50);
    text-transform: uppercase;
    letter-spacing: 0.04em;

    &Link {
      @include inter-medium;
      font-size: 14px;
      float: left;
      line-height: 42px;
      padding-right: 19px;
      color: var(--action-50);

      span:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &.editing {
      @include inter-medium;
      font-size: 15px;
      color: var(--neutral-50);
    }
  }
}

.sectionInput {
  @include inter-regular;
  font-size: 17px;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
  color: var(--neutral-40);
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
  resize: none;

  input {
    background-color: var(--neutral-0);
    text-align: right;
    width: 19em;

    &::placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 17px;
      line-height: 21px;
      text-align: right;
      color: var(--neutral-40);
    }
  }

  .text {
    @include md-regular;
    b {
      color: var(--negative-50);
    }
  }
}

.buttons {
  margin: -72px -32px 40px;
  text-align: right;
}

.button {
  &Edit,
  &Cancel,
  &Save {
    @include inter-medium;
    font-size: 14px;
    border-radius: 4px;
    padding: 6px 12px;
    width: 118px;
    height: 32px;
  }

  &Edit,
  &Save {
    background: var(--action-50);
    border: 1px solid var(--action-60);
    box-sizing: border-box;
    @include shadow;
    border-radius: 4px;
    color: var(--neutral-0);

    &.saving {
      opacity: 0.8;
    }
  }

  &Cancel {
    background-color: var(--neutral-0);
    color: var(--neutral-50);
  }
}

.hide {
  display: none;
}

.middle {
  display: flex;
  align-content: center;
  margin-left: auto;
  position: relative;
}

.errors {
  @include inter-medium;
  display: flex;
  margin-left: 275px;
  position: absolute;
  font-size: 15px;
  line-height: 21px;
  color: var(--negative-50);
  text-align: right;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
  border-radius: 12px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 12px;
}

.slider:before {
  position: absolute;
  content: '';
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 3px;

  background-color: var(--neutral-0);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--action-50);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--action-50);
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.link {
  @include inter-medium;
  color: var(--action-50);

  &:hover {
    cursor: pointer;
  }
}

.social {
  @include inter-regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 21px;

  &Value {
    color: var(--neutral-90);
  }

  &Url {
    color: var(--neutral-50);
  }

  &AddLink {
    color: var(--action-50);

    cursor: pointer;
  }

  &Placeholder {
    padding-right: 2px;

    &:empty:not(:focus):before {
      content: attr(data-text);
    }
  }
}

.span {
  &Label {
    @include inter-regular-italic;
    font-size: 14px;
    line-height: 21px;
    color: var(--neutral-50);
    margin-right: 16px;
  }
}

.socialLinkSection {
  display: flex;
  width: 19rem;
  justify-content: flex-end;

  [contenteditable]:focus {
    outline: 0px solid transparent;
  }
}

.password {
  &Text {
    @include inter-medium;
    cursor: pointer;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: var(--action-50);
  }
}
